
import type { MeVo } from "@zhihaoscm/entity";
import { defineStore } from "pinia";

interface IStoreProps {
    token: string;
    userInfo: MeVo | null;
}

export const useUserStore = defineStore("zhihao-user", {
    state: (): IStoreProps => ({
        token: "",
        // 用户信息
        userInfo: null
    }),
    actions: {
        setToken(token: string) {
            this.token = token;
        }
    },
    persist: {
        storage: window.sessionStorage,
        pick: ["token"],
        beforeHydrate: (context) => {
            const userContext = window.sessionStorage.getItem("zhihao-user");

            if(userContext) {
                context.store.token = JSON.parse(userContext).token || "";
            }
        }
    }
});
